namespace $.$$ {

	export class $shm_ba_agent_message_text extends $.$shm_ba_agent_message_text {

		posts_block( index: number ) {
			const token = this.flow_tokens()[ index ]
			return token?.name === 'code' && token.chunks[ 1 ].trim().toLowerCase() === 'ba-posts'
		}

		@ $mol_mem_key
		posts_result( index: number ) {
			return $shm_ba_agent_message_posts_parse( this.pre_text( index ) )
		}

		posts_table( index: number ) {
			return this.posts_result( index ).table
		}

		posts_error( index: number ) {
			return `Не удалось показать посты BA: ${ this.posts_result( index ).error }`
		}

		posts_invalid_rows( index: number ) {
			return [ this.Posts_error( index ), this.Pre( index ) ]
		}

		override rows() {
			const rows = [ ... super.rows() ]
			for( const [ index ] of this.flow_tokens().entries() ) {
				if( !this.posts_block( index ) ) continue
				rows[ index ] = this.posts_result( index ).table
					? this.Posts( index )
					: this.Posts_invalid( index )
			}
			return rows
		}

	}

}
